const DeleteAccountSetting = () => {
  return (
    <>
      <div className="setting-detail-list">
        <div className="detail">
          <div className="delete-account">
            <div className="inner-acc-summary">
              <strong className="deletacc">Delete your HubSpot Account</strong>
              <p className="m-0 accountown">
                Delete this account HubSpot ID (45465#) and everything associate
                wit it.
              </p>
            </div>
            <button>Delete account</button>
          </div>
        </div>
      </div>
    </>
  );
};
export default DeleteAccountSetting;
